import { useNavigate } from "react-router-dom";
import { IoIosSearch } from "react-icons/io";
import { MdKeyboardDoubleArrowLeft, MdNotifications } from "react-icons/md";
import { FaCalendarDays } from "react-icons/fa6";
import { useEffect, useRef, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import ClickOutside from "../ClickOutside";
import DropdownUser from "./DropdownUser";
import Breadcrumb from "../Breadcrumbs/Breadcrumb";
import { FaBarsStaggered } from "react-icons/fa6";
import { RiArrowRightDoubleFill } from "react-icons/ri";

const Header = ({
  sidebarOpen,
  setSidebarOpen,
  sidebarCollapsed,
  setSidebarCollapsed,
}) => {
  const navigate = useNavigate();
  const trigger = useRef(null);
  const sidebar = useRef(null);

  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!sidebarOpen || keyCode !== 27) return;
      setSidebarOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  });
  const [userName, setUserName] = useState("");
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);
  const notificationBtnRef = useRef(null);

  useEffect(() => {
    const storedUserName = sessionStorage.getItem("userName");
    if (storedUserName) {
      setUserName(storedUserName);
    }
  }, []);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      const response = await axiosInstance.get(
        "/Followup/GetAllTodayNotification"
      );
      const todayNotifs = response.data || [];
      setNotifications(todayNotifs);
      setNotificationCount(todayNotifs.length);
    } catch (error) {
      console.error("Failed to fetch notifications:", error);
    }
  };

  return (
    <>
      <header className="sticky top-0 z-50 flex flex-col w-full bg-white shadow">
        <div className="flex items-center justify-between px-4 py-2 md:px-6 2xl:px-11">
          <div className="flex items-center gap-4">
            <div className="lg:hidden">
              <button
                aria-controls="sidebar"
                onClick={(e) => {
                  e.stopPropagation();
                  setSidebarOpen(!sidebarOpen);
                }}
                className="w-10 h-10 rounded-md bg-white shadow flex flex-col items-center justify-center gap-1.5"
              >
                <FaBarsStaggered />
              </button>
            </div>

            <div className="hidden lg:block">
              <button
                ref={sidebar}
                onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                className="w-8 h-8 bg-gray-200 rounded flex items-center justify-center"
              >
                {sidebarCollapsed ? (
                  <RiArrowRightDoubleFill className="w-5 h-5 text-gray-600" />
                ) : (
                  <MdKeyboardDoubleArrowLeft className="w-5 h-5 text-gray-600" />
                )}
              </button>
            </div>

            {/* <div className="hidden sm:block">
              <form>
                <div className="relative">
                  <button className="absolute left-2 top-1/2 -translate-y-1/2 p-1">
                    <IoIosSearch className="w-5 h-5 text-gray-500" />
                  </button>
                  <input
                    type="text"
                    placeholder="Search..."
                    className="pl-9 pr-4 py-1.5 w-72 bg-gray-100 text-sm rounded-md focus:outline-none"
                  />
                </div>
              </form>
            </div> */}
          </div>

          <div className="flex items-center gap-4">
            <button onClick={() => navigate("/calendar")}>
              <FaCalendarDays className="w-5 h-5 text-gray-600" />
            </button>

            <button
              ref={notificationBtnRef}
              onClick={() => setShowNotifications((prev) => !prev)}
              className="relative"
            >
              <MdNotifications className="w-5 h-5 text-gray-600" />
              {notificationCount > 0 && (
                <span className="absolute -top-1 -right-1 h-4 w-4 flex items-center justify-center text-[10px] text-white bg-red-600 rounded-full">
                  {notificationCount}
                </span>
              )}
            </button>

            <DropdownUser userName={userName} />
          </div>
        </div>

        <div className="w-full px-4 py-2 md:px-6 2xl:px-11 border-t border-gray-100 bg-white">
          <Breadcrumb />
        </div>
      </header>

      {showNotifications && (
        <ClickOutside
          exceptionRef={notificationBtnRef}
          onClick={() => setShowNotifications(false)}
          className="absolute right-12 top-16 z-50 w-72 max-h-96 overflow-y-auto rounded-md border border-gray-300 bg-white p-3 shadow-lg"
        >
          <h4 className="mb-2 text-sm font-semibold">Today's Notifications</h4>
          {notifications.length === 0 ? (
            <p className="text-xs text-gray-500">No new notifications</p>
          ) : (
            <ul className="space-y-2">
              {notifications.map((item, index) => (
                <li
                  key={index}
                  className="rounded bg-gray-100 p-2 text-sm shadow-sm hover:bg-gray-200"
                >
                  {item.subject}
                </li>
              ))}
            </ul>
          )}
        </ClickOutside>
      )}
    </>
  );
};

export default Header;
